<template>
	<div>
		<!----- Headline ------>
		<v-list-item height="30">
			<v-btn icon class="d-flex d-md-none">
				<v-icon>mdi-arrow-left</v-icon>
			</v-btn>
			<v-list-item-content class="px-2 py-4">
				<v-list-item-title class="text-h6">JohnSnow</v-list-item-title>
				<v-list-item-title class="text-caption text--secondary">Last login: 31/04/2021 15:05:30</v-list-item-title>
			</v-list-item-content>
			<v-btn icon class="d-none d-md-block">
				<v-icon>mdi-help-circle-outline</v-icon>
			</v-btn>
		</v-list-item>
		<v-divider class="mb-3 d-none d-md-flex d-md-none"></v-divider>

		<!----- Main Components ------>

		<v-row>
			<v-col cols="12" class="d-flex flex-column">
				<banner-content></banner-content>
			</v-col>

			<v-col cols="12" md="6">
				<v-list-item-content class="px-2 py-4">
					<v-list-item-title class="text-h6">Your profile</v-list-item-title>
				</v-list-item-content>
				<account-info></account-info>
			</v-col>
		</v-row>
		<v-spacer class="my-8"></v-spacer>

		<!----- Side Components ------>
		<!-- <v-snackbar v-model="snackbar">
			<div class="font-weight-bold">{{ pageName }}</div>
			<template v-slot:action="{ attrs }">
				<v-btn color="orange" text v-bind="attrs" @click="snackbar = false">
					Okay
				</v-btn>
			</template>
		</v-snackbar> -->
	</div>
</template>

<script>
import bannerInContent from "../components/myAccount/dashboard/bannerInContent"
import accountInfo from "../components/profile/accountInfo"

export default {
	data() {
		return {
			pageName: "Profile!",
			snackbar: true,
		}
	},
	components: {
		"banner-content": bannerInContent,
		"account-info": accountInfo,
	},
}
</script>
<style lang="sass" scoped>
.v-application--wrap .v-main
	padding: 2rem 0px 0px !important

.text-h5
	font-family: "Inter", sans-serif !important
	font-weight: 600

.wrap-main
	display: flex
	justify-content: flex-start
	height: 100%

.row
	margin: 0.5rem

.full-width
	width: 100%
</style>
